import React from "react";

function Cancer() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.159 496.159"
      enableBackground="new 0 0 496.159 496.159"
    >
      <path
        fill="#58D1DD"
        d="M248.083,0.003C111.071,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.083,248.07
	c137.006,0,248.076-111.069,248.076-248.07C496.159,111.062,385.089,0.003,248.083,0.003z"
      />
      <path
        fill="#9B0000"
        d="M303.188,423.508l-33.423-17.507c-0.256-0.134-0.564-0.126-0.814,0.019
	c-6.245,3.637-13.365,5.56-20.589,5.56c-0.051,0-0.095,0.021-0.144,0.029c-0.049-0.008-0.093-0.029-0.144-0.029
	c-7.224,0-14.343-1.923-20.588-5.56c-0.25-0.145-0.558-0.152-0.814-0.019l-33.423,17.507c-0.363,0.189-0.537,0.614-0.411,1.003
	c6.388,19.814,29.102,33.653,55.236,33.653c0.051,0,0.095-0.021,0.144-0.028c0.048,0.008,0.093,0.028,0.144,0.028
	c26.135,0,48.85-13.838,55.236-33.653C303.725,424.122,303.551,423.698,303.188,423.508z"
      />
      <path
        fill="#AA0404"
        d="M248.36,411.585c-0.028,0.006-0.108,0.018-0.142,0.024c-0.049-0.008-0.093-0.029-0.144-0.029
	c-7.224,0-14.343-1.923-20.588-5.56c-0.25-0.145-0.558-0.152-0.814-0.019l-33.423,17.507c-0.363,0.189-0.537,0.614-0.411,1.003
	c6.388,19.814,29.102,33.653,55.236,33.653c0.051,0,0.095-0.021,0.144-0.028c0.034,0.005,0.113,0.017,0.142,0.023
	C248.076,457.952,248.076,411.793,248.36,411.585z"
      />
      <g>
        <path
          fill="#840303"
          d="M351.846,201.877c-1.965-2.806-2.806-0.562-2.806-0.562c5.332,31.431-7.858,47.427-7.858,47.427
		c-8.699,13.19-56.968,23.573-56.968,23.573l-1.123,11.225c71-10.383,73.807-48.549,73.807-48.549
		C365.035,207.769,351.846,201.877,351.846,201.877z"
        />
        <path
          fill="#840303"
          d="M378.225,246.497c-0.28-5.051-2.245-3.087-2.245-3.087c-2.526,36.762-26.66,45.462-26.66,45.462
		c-9.261,0.561-31.712,5.052-31.712,5.052c-14.592-5.894-34.236-6.454-34.236-6.454s-8.139,9.261-0.842,10.664
		c7.297,1.402,36.763,3.929,36.763,3.929c47.988-3.087,51.355-19.364,51.355-19.364C384.96,267.265,378.225,246.497,378.225,246.497
		z"
        />
        <path
          fill="#840303"
          d="M305.121,181.672l-2.666,0.14c0,0-12.629-7.577-23.152-7.998c0,0,45.042,26.099,37.043,52.198
		c0,0-10.524,17.68-36.202,26.52l2.105,9.682c0,0,37.885-13.471,41.253-33.676C323.502,228.537,330.377,194.301,305.121,181.672z"
        />
      </g>
      <path
        fill="#9B0000"
        d="M358.44,186.443c-7.577,2.104-4.63-9.261-4.63-9.261c-8.419,10.103-26.941,0.421-26.941,0.421
	l-16.417,21.047l-42.937-1.263l9.682,25.678l27.362,1.263l-3.789-4.63l30.308-2.947L358.44,186.443z"
      />
      <path
        fill="#840303"
        d="M360.545,135.368c-49.952,3.368-95.976,31.711-95.976,31.711c-8.138,4.491-8.699,21.608-8.699,21.608
	l10.103,8.7l0.562-10.665c3.306-22.45,23.853-24.976,23.853-24.976c21.89-12.629,75.209-19.645,75.209-19.645
	c19.364,0,34.237,22.731,34.237,22.731C395.344,139.016,360.545,135.368,360.545,135.368z"
      />
      <g>
        <path
          fill="#9B0000"
          d="M274.111,121.898c-21.047,21.048-25.963,64.243-25.963,64.243l3.653,1.003
		c1.684-38.868,21.889-62.44,21.889-62.44C274.812,122.319,274.111,121.898,274.111,121.898z"
        />
        <path
          fill="#9B0000"
          d="M353.81,117.687c-9.541-38.167-55.846-71-55.846-71c-25.257-15.154-35.64-5.894-35.64-5.894
		c34.798,29.747,48.83,86.996,48.83,86.996c-43.778-56.688-49.953-81.944-49.953-81.944
		c-26.099,47.471,63.563,129.231,63.563,129.231c21.468,10.804,29.327-0.421,29.327-0.421l4.77,5.893
		c0-3.929,7.017-14.032,7.017-14.032C365.878,155.573,353.81,117.687,353.81,117.687z"
        />
        <path
          fill="#9B0000"
          d="M185.708,198.65l-16.417-21.047c0,0-18.522,9.682-26.941-0.421c0,0,2.947,11.366-4.63,9.261
		l27.362,30.308l30.308,2.947l-3.789,4.63l27.362-1.263l9.682-25.678L185.708,198.65z"
        />
      </g>
      <g>
        <path
          fill="#840303"
          d="M211.946,272.316c0,0-48.269-10.383-56.968-23.573c0,0-13.19-15.997-7.858-47.427
		c0,0-0.841-2.245-2.806,0.562c0,0-13.189,5.893-5.052,33.115c0,0,2.806,38.166,73.807,48.549L211.946,272.316z"
        />
        <path
          fill="#840303"
          d="M212.788,287.47c0,0-19.644,0.561-34.236,6.454c0,0-22.451-4.491-31.712-5.052
		c0,0-24.134-8.7-26.66-45.462c0,0-1.964-1.964-2.245,3.087c0,0-6.735,20.767,7.577,36.202c0,0,3.368,16.276,51.355,19.364
		c0,0,29.466-2.527,36.763-3.929C220.927,296.731,212.788,287.47,212.788,287.47z"
        />
        <path
          fill="#840303"
          d="M179.814,226.012c-7.998-26.099,37.043-52.198,37.043-52.198
		c-10.523,0.421-23.152,7.998-23.152,7.998l-2.666-0.14c-25.257,12.628-18.381,46.865-18.381,46.865
		c3.368,20.205,41.253,33.676,41.253,33.676l2.105-9.682C190.338,243.692,179.814,226.012,179.814,226.012z"
        />
        <path
          fill="#840303"
          d="M231.591,167.079c0,0-46.024-28.344-95.977-31.711c0,0-34.799,3.648-39.289,29.466
		c0,0,14.874-22.731,34.237-22.731c0,0,53.32,7.016,75.209,19.645c0,0,20.547,2.526,23.853,24.976l0.562,10.665l10.103-8.7
		C240.29,188.688,239.729,171.57,231.591,167.079z"
        />
      </g>
      <g>
        <path
          fill="#9B0000"
          d="M222.049,121.898c0,0-0.702,0.421,0.421,2.806c0,0,20.206,23.572,21.889,62.44l3.653-1.003
		C248.012,186.141,243.097,142.946,222.049,121.898z"
        />
        <path
          fill="#9B0000"
          d="M234.958,45.846c0,0-6.174,25.257-49.953,81.944c0,0,14.032-57.249,48.83-86.996
		c0,0-10.383-9.261-35.64,5.894c0,0-46.305,32.833-55.846,71c0,0-12.068,37.885-12.068,48.83c0,0,7.017,10.103,7.017,14.032
		l4.77-5.893c0,0,7.858,11.225,29.327,0.421C171.395,175.077,261.058,93.317,234.958,45.846z"
        />
      </g>
      <path
        fill="#B50606"
        d="M248.148,186.141c-18.481,0-42.24,23.033-42.24,94.805c0,101.027,14.742,127.758,42.24,127.758
	c27.497,0,42.239-26.169,42.239-127.758C290.387,209.595,266.629,186.141,248.148,186.141z"
      />
      <path
        fill="#CC0E0E"
        d="M205.908,280.946c0,101.027,14.742,127.758,42.24,127.758V186.141
	C229.666,186.141,205.908,209.174,205.908,280.946z"
      />
      <g>
        <ellipse
          transform="matrix(-0.9824 -0.1868 0.1868 -0.9824 427.4489 465.6473)"
          fill="#660000"
          cx="235.663"
          cy="212.685"
          rx="4.771"
          ry="7.437"
        />

        <ellipse
          transform="matrix(-0.1978 -0.9802 0.9802 -0.1978 104.5387 510.9084)"
          fill="#660000"
          cx="261.323"
          cy="212.679"
          rx="7.437"
          ry="4.771"
        />
      </g>
      <g>
        <path
          fill="#840303"
          d="M248.582,318.117c-25.339,0-40.14-6.498-40.14-6.498s37.611,24.256,79.7,0
		C288.142,311.619,273.92,318.117,248.582,318.117z"
        />
        <path
          fill="#840303"
          d="M248.555,339.992c-22.96,0-36.373-5.888-36.373-5.888s34.082,21.98,72.22,0
		C284.402,334.104,271.516,339.992,248.555,339.992z"
        />
        <path
          fill="#840303"
          d="M248.523,360.908c-20.168,0-31.947-5.171-31.947-5.171s29.935,19.306,63.433,0
		C280.009,355.737,268.69,360.908,248.523,360.908z"
        />
        <path
          fill="#840303"
          d="M248.495,379.643c-17.769,0-28.148-4.556-28.148-4.556s26.376,17.01,55.893,0
		C276.239,375.087,266.265,379.643,248.495,379.643z"
        />
      </g>
      <path
        fill="#B50606"
        d="M252.099,183.076l-4.019,0.935l0.171,7.755l3.874-0.009
	C252.064,191.757,252.099,183.076,252.099,183.076z"
      />
      <polygon fill="#CC0E0E" points="248.126,184.011 244.074,183.076 244.048,191.775 248.158,191.792 " />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Cancer;
